import { FunctionComponent, useState, useEffect } from 'react';
import { calculate } from '../api';
import {
  QuestionType,
  CategoryType,
  QuestionAnswer,
  RoomType,
  CalculateProps,
  DefaultValue,
} from './../types';
import Question from './Question';

import { useCategoriesOfferContext } from '../context/CategoriesOfferContext';
import CategoryControls from './CategoryControls';
import CategoryInfo from './CategoryInfo';

interface CategoryProps {
  room?: RoomType;
  category?: CategoryType;
  questions: QuestionType[];
  disabled: boolean;
  setAnswer: (question: QuestionType, answer: string) => void;
  defaultValue?: Array<DefaultValue>;
  yearError?: boolean;
  last?: boolean;
  label?: string;
  customer?: string;
  className?: string;
}

const Category: FunctionComponent<CategoryProps> = ({
  category,
  questions,
  setAnswer,
  disabled,
  room,
  defaultValue,
  yearError,
  label,
  className,
  customer = 'hemfixarna',
}: CategoryProps) => {
  const [form, setForm] = useState<QuestionAnswer[]>(
    defaultValue?.map((v) => ({
      question: v.question.key,
      answer: v.answer || (v.question.key.startsWith('count_') ? 0 : undefined),
    })) || []
  );

  const { addData, editMode } = useCategoriesOfferContext();

  const answered = (question: QuestionType, answer: string) => {
    setAnswer(question, answer);
    const f = [
      ...form.filter((i) => i.question !== question.key),
      { question: question.key, answer },
    ];
    setForm(f);
  };

  const getPrice = async (data: CalculateProps) => {
    const offert = await calculate(data);
    addData(category?.label || '', offert);
  };

  useEffect(() => {
    if (!editMode || (editMode && defaultValue?.length === 0)) {
      setForm(
        questions.map((q) => ({
          question: q.key,
          answer: q.key.startsWith('count_') ? '0' : undefined,
        }))
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue?.length, editMode, questions]);

  useEffect(() => {
    if (
      category &&
      category.key.toString() !== 'base' &&
      room &&
      form.length &&
      form.filter((i) => undefined !== i.answer).length === form.length
    ) {
      getPrice({ answers: form, category: category.key, room });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category, room, form]);

  if (!category) return null;

  return (
    <div className={`calculator_card ${className}`}>
      <div className="calculator_wrapper">
        <h2 className="text-center calculator_category_title">
          {label || category.label}
        </h2>
        {category.info?.length && <CategoryInfo info={category.info} />}
        {questions.map((q) => (
          <Question
            onAnswer={(answer) => answered(q, answer)}
            question={q}
            hideLabel={category.key.toString() === 'base'}
            defaultValue={
              defaultValue?.find((e) => e.question.key === q.key)?.answer
            }
            key={q.id}
            disabled={category.key.toString() === 'base' ? false : disabled}
          />
        ))}
        {yearError && questions[0]?.key === 'year' && (
          <span className="calculator_qerror">Välj årtal på fastigheten</span>
        )}
      </div>
      <CategoryControls customer={customer} />
    </div>
  );
};

export default Category;
